import { render } from "./CloseAdmissionSection.vue?vue&type=template&id=a8e84c16&scoped=true"
import script from "./CloseAdmissionSection.vue?vue&type=script&lang=js"
export * from "./CloseAdmissionSection.vue?vue&type=script&lang=js"

import "./CloseAdmissionSection.vue?vue&type=style&index=0&id=a8e84c16&scoped=true&lang=css"

import exportComponent from "../../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8e84c16"]])

export default __exports__